// extracted by mini-css-extract-plugin
export var action = "privacyWarning-module--action--1e20b";
export var container = "privacyWarning-module--container--54e45";
export var text = "privacyWarning-module--text--f2a87";
export var wrap = "privacyWarning-module--wrap--9a24e";